import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { adminMainUrl } from '../../../../../Config';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Select from 'react-select'
import { customStyles } from '../../../../../HelperFunctions';
import TextAreaJSX from './TextAreaJSX';
import InputTextJSX from './InputTextJSX';
import InputDateJSX from './InputDateJSX';
import SelectReactJSX from './SelectReactJSX';
import { useDispatch, useSelector } from 'react-redux';
import { getDimensionByQuotation, getFFAirExpConsigneeBranch, getFFAirExpConsigneeBranchBank, getFFAirExpOrganisationBranch, getFFAirExportHAWBStocks, getFFAirExpShipperBranch, getFFAirExpShipperBranchBank, getPackageInfoByQuotation } from '../../../../../Redux/action/FreightForwarding/Console/FFAirExpAction';
import { error } from 'jquery';
import { getChargehead, getRateclassList } from '../../../../../Redux/action/MasterAction';

const ConsoleShipmentHAWBAdd = ({
    trans_mode,
    impexp,
    job_order_id,
    quotation_id,
    loadingCurrency,
    currencyOptions,
    loadingAirport,
    airportOptions,
    loadingOrganisation,
    organisationOptions,
    token,
    user_id,
    accessedPermission,
    joborderffdetails,
    iataAgentOptions
}) => {
    const [disableSubmit, setDisableSubmit] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();


    let [shipperOrganisationOptions, setShipperOrganisationOptions] = useState([]);
    let [consigneeOrganisationOptions, setConsigneeOrganisationOptions] = useState([]);

    let [shipperBranchOptions, setShipperBranchOptions] = useState([]);
    let [consigneeBranchOptions, setConsigneeBranchOptions] = useState([]);

    let [shipperBankOptions, setShipperBankOptions] = useState([]);
    let [consigneeBankOptions, setConsigneeBankOptions] = useState([]);


    let [hawbStockOptions, setHAWBStockOptions] = useState([]);

    useEffect(() => {
        if (quotation_id) {
            dispatch(getDimensionByQuotation(token, user_id, quotation_id));
        }
    }, [quotation_id])

    useEffect(() => {
        if (token && user_id) {
            dispatch(getFFAirExportHAWBStocks(token, user_id));
            dispatch(getChargehead(token, user_id));
            dispatch(getRateclassList(token, user_id));
        }
    }, []);

    let [impExp, setImpExp] = useState([]);
    let [chargeHeadOptions, setChargeHeadOptions] = useState([]);

    const {
        loadingChargehead,
        chargeheadData,
        RateclassList
    } = useSelector(state => state.MasterReducer);

    let [rateclassOptions, setRateclassOptions] = useState([]);
    useEffect(() => {
        if (RateclassList) {
            let arr = [];
            RateclassList.map((v) => { arr.push({ label: v.name, value: v.id }) });
            setRateclassOptions(arr);
        } else {
            setRateclassOptions([]);
        }
    }, [RateclassList]);


    useEffect(() => {
        if (chargeheadData) {
            let arr = [];
            chargeheadData.map(v => { arr.push({ value: v.id, label: v.name }) });
            setChargeHeadOptions(arr);
        } else {
            setChargeHeadOptions([]);
        }
    }, [chargeheadData])

    useEffect(() => {
        if (organisationOptions) {
            let shipperArr = [];
            let consigneeArr = [];

            organisationOptions.map(object => {
                if (object.entity && object.entity.includes("shipper")) {
                    shipperArr.push(object);
                }
                if (object.entity && object.entity.includes("consignee")) {
                    consigneeArr.push(object);
                }
            });
            setShipperOrganisationOptions(shipperArr);
            setConsigneeOrganisationOptions(consigneeArr);
        }
    }, [organisationOptions]);


    useEffect(() => {
        if (token && user_id && quotation_id) {
            dispatch(getPackageInfoByQuotation(token, user_id, quotation_id))
        }
    }, [quotation_id]);


    const handleShipperBranch = (shipper_id) => {
        if (shipper_id && token && user_id) {
            dispatch(getFFAirExpShipperBranch(token, user_id, shipper_id));
        }
    };
    const handleShipperBanks = (branch_id) => {
        if (branch_id && token && user_id) {
            dispatch(getFFAirExpShipperBranchBank(token, user_id, branch_id));
        }
    };

    const handleConsigneeBranch = (consignee_id) => {
        if (consignee_id && token && user_id) {
            dispatch(getFFAirExpConsigneeBranch(token, user_id, consignee_id));
        }
    };
    const handleConsigneeBanks = (branch_id) => {
        if (branch_id && token && user_id) {
            dispatch(getFFAirExpConsigneeBranchBank(token, user_id, branch_id));
        }
    };


    const {
        //organisation shipper branch list
        loadingFFAirExpShipperBranchList,
        FFAirExpShipperBranchList,
        FFAirExpShipperBranchListError,

        //organisation consignee branch list
        loadingFFAirExpConsigneeBranchList,
        FFAirExpConsigneeBranchList,
        FFAirExpConsigneeBranchListError,

        //organisatoin shipper branch bank list
        loadingFFAirExpShipperBranchBankList,
        FFAirExpShipperBranchBankList,
        FFAirExpShipperBranchBankListError,

        //organisatoin consignee branch bank list
        loadingFFAirExpConsigneeBranchBankList,
        FFAirExpConsigneeBranchBankList,
        FFAirExpConsigneeBranchBankListError,

        //query INFO
        loadingFFQueryDetail,
        FFQueryDetail,
        FFQueryDetailError,


        loadingFFAirExpHAWBStocks,
        FFAirExpHAWBStocks,
        FFAirExpHAWBStocksError,

        DimensionByQuotation,
    } = useSelector(state => state.FFAirExpReducer);


    useEffect(() => {
        if (FFAirExpHAWBStocks) {
            let arr = [];
            FFAirExpHAWBStocks.map(val => arr.push({ value: val.id, label: val.final_hawb_stock_number }));
            setHAWBStockOptions(arr);
        }
    }, [FFAirExpHAWBStocks])

    useEffect(() => {
        // console.log(FFAirExpShipperBranchList);
        if (FFAirExpShipperBranchList) {
            let arr = [];
            FFAirExpShipperBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setShipperBranchOptions(arr);
        }
    }, [FFAirExpShipperBranchList]);


    useEffect(() => {
        if (FFAirExpShipperBranchBankList) {
            let arr = [];
            FFAirExpShipperBranchBankList.map(val => arr.push({ value: val.id, label: val.entity_name }));
            setShipperBankOptions(arr);
        }
    }, [FFAirExpShipperBranchBankList]);

    useEffect(() => {
        if (FFAirExpConsigneeBranchList) {
            let arr = [];
            FFAirExpConsigneeBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setConsigneeBranchOptions(arr);
        }
    }, [FFAirExpConsigneeBranchList]);

    useEffect(() => {
        if (FFAirExpConsigneeBranchBankList) {
            let arr = [];
            FFAirExpConsigneeBranchBankList.map(val => arr.push({ value: val.id, label: val.entity_name }));
            setConsigneeBankOptions(arr);
        }
    }, [FFAirExpConsigneeBranchBankList]);


    const initialValues = {
        hawb_stock_id: 0,
        job_order_id: 0,
        quotation_id: 0,
        shipper_id: "",
        shipper_branch_id: "",
        shipper_branch_bank_account_id: "",
        consignee_id: "",
        consignee_branch_id: "",
        consignee_branch_bank_account_id: "",
        issuing_carrier_agent_id: 0,
        issuing_carrier_agent_name: "",
        issuing_carrier_agent_address: "",
        agent_iata_code: "",
        agent_account_number: "",
        handling_info: "",
        nature_and_qty: "",
        remarks: "",
        airwaybill_date: "",
        clearance_Exec_date: "",
        CSR_date: "",
        executed_at: "",
        is_sli_recived: "",
        airport_of_departure_id: "",
        airport_of_departure_name: "",
        airport_of_destination_id: "",
        airport_of_destination_name: "",
        to_one: "",
        by_first_carrier: "",
        to_two: "",
        by_one: "",
        to_three: "",
        by_two: "",
        flight_no_one: "",
        flight_date_one: "",
        flight_no_two: "",
        flight_date_two: "",
        cto: "",
        currency: "",
        chgs_code: "",
        wt_val: "",
        other: "",
        declared_value_for_carriage: "",
        declared_value_for_customs: "",
        amount_of_insurance: "",
        // rate_description_json: [
        //     {
        //         no_of_pkg: 1,
        //         gross_wt: "",
        //         kg_lb: "",
        //         rate_class: "",
        //         comm_item_No: "",
        //         chargeable_wt: "",
        //         rate_charge: "",
        //         total_freight: ""
        //     }
        // ],
        weight_charge_prepaid: "0",
        weight_charge_collect: "0",
        valuation_charge_prepaid: "0",
        valuation_charge_collect: "0",
        tax_prepaid: "0",
        tax_collect: "0",
        total_due_agent_prepaid: "0",
        total_due_agent_collect: "0",
        total_due_carrier_prepaid: "0",
        total_due_carrier_collect: "0",
        total_prepaid: "0",
        total_collect: "0",


        //rate description
        // no_of_pkg1: "",
        // gross_wt1: "",
        // kg_lb1: "",
        // rate_class1: "",
        // comm_item_No1: "",
        // chargeable_wt1: "",
        // rate_charge1: "",
        // total_freight1: "",

        // no_of_pkg2: "",
        // gross_wt2: "",
        // kg_lb2: "",
        // rate_class2: "",
        // comm_item_No2: "",
        // chargeable_wt2: "",
        // rate_charge2: "",
        // total_freight2: "",

        // no_of_pkg3: "",
        // gross_wt3: "",
        // kg_lb3: "",
        // rate_class3: "",
        // comm_item_No3: "",
        // chargeable_wt3: "",
        // rate_charge3: "",
        // total_freight3: "",

        // no_of_pkg4: "",
        // gross_wt4: "",
        // kg_lb4: "",
        // rate_class4: "",
        // comm_item_No4: "",
        // chargeable_wt4: "",
        // rate_charge4: "",
        // total_freight4: "",

        rows: [
            {
                no_of_pkg: "",
                gross_wt: "",
                kg_lb: "",
                rate_class: "",
                comm_item_No: "",
                chargeable_wt: "",
                rate_charge: "",
                total_freight: "",
            }
        ],
        due_carrier_charge_rows: [
            {
                charge_head_id: 0,
                rate: 0,
                amount: 0,
                csr_amount: 0,
                p_c: "",
            }
        ],
        due_agent_charge_rows: [
            {
                charge_head_id: 0,
                self_amount: 0,
                sub_agent_amount: 0,
                tie_up_amount: 0,
                iata_amount: 0,
                stax_amount: 0,
                ecess_amount: 0,
                hcess_amount: 0,
                sbcess_amount: 0,
                kkc_amount: 0,
                rate: 0,
                amount: 0,
                bill_amount: 0,
                p_c: "",
            }
        ],
        dimension_rows: [
            {
                length: 0,
                width: 0,
                height: 0,
                pkgs: 0,
                unit: "",
            }
        ]

    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            // console.log(values);
            values.job_order_id = job_order_id;
            values.quotation_id = quotation_id;

            // let rateArr = [];
            // for (let i = 1; i <= 4; i++) {
            //     const obj = {
            //         no_of_pkg: values[`no_of_pkg${i}`],
            //         gross_wt: values[`gross_wt${i}`],
            //         kg_lb: values[`kg_lb${i}`],
            //         rate_class: values[`rate_class${i}`],
            //         comm_item_No: values[`comm_item_No${i}`],
            //         chargeable_wt: values[`chargeable_wt${i}`],
            //         rate_charge: values[`rate_charge${i}`],
            //         total_freight: values[`total_freight${i}`],
            //     };
            //     // console.log(obj);
            //     const hasValue = Object.values(obj).some(value => value !== "");
            //     if (hasValue) {
            //         rateArr.push(obj);
            //     }
            // }
            // values.rate_description_json = rateArr;
            values.rate_description_json = values.rows;
            values.due_carrier_charges_description_json = values.due_carrier_charge_rows;
            values.due_agent_charges_description_json = values.due_agent_charge_rows;
            values.dimension_json = values.dimension_rows;

            // console.log(values);
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                axios.post(`${adminMainUrl}/api/freight/forwarding/air/${impExp}/hawb/add`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            resetForm();
                            //reset all the dropdowns
                            setShipperOrganisationOptions([]);
                            setConsigneeOrganisationOptions([]);
                            setShipperBranchOptions([]);
                            setConsigneeBranchOptions([]);
                            setShipperBankOptions([]);
                            setConsigneeBankOptions([]);
                            navigate(`/flexichain/job-order/freight-forwarding/shipment/air/${impExp}/console/hawb`)

                            // navigate(`/flexichain/job-order/edit/${btoa(response.data.data.id)}`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });


    useEffect(() => {
        if (DimensionByQuotation) {
            if (DimensionByQuotation.package_volume_type == "DIMENSIONS" && Array.isArray(DimensionByQuotation.query_dimension) && DimensionByQuotation.query_dimension.length) {
                let setArr = [];
                DimensionByQuotation.query_dimension.map((val, index) => {
                    let json = {
                        length: val.length,
                        width: val.width,
                        height: val.height,
                        pkgs: val.total_boxes,
                        unit: val.dimensionunit,
                    };

                    setArr.push(json);
                });

                formik.setFieldValue("dimension_rows", setArr);
            };
        }
    }, [DimensionByQuotation])


    useEffect(() => {
        if (FFQueryDetail) {
            // console.log(FFQueryDetail);

            if (FFQueryDetail.pl_package_info) {
                let parsedJSON = JSON.parse(FFQueryDetail.pl_package_info);
                if (Array.isArray(parsedJSON)) {
                    const updatedRows = parsedJSON.map((item) => {
                        // Extract values from API response
                        const { total_boxes, gross_weight, gross_weight_unit } = item;

                        // Determine the correct kg_lb value (case insensitive match)
                        const validUnits = ["kgs", "lbs", "ton"];
                        const kg_lb = validUnits.includes(gross_weight_unit.toLowerCase())
                            ? gross_weight_unit
                            : ""; // Set to empty if invalid

                        // Map fields to form row structure
                        return {
                            no_of_pkg: total_boxes || "", // Map total_boxes to no_of_pkg
                            gross_wt: gross_weight || "", // Map gross_weight to gross_wt
                            kg_lb: kg_lb || "-",         // Map kg_lb based on validation
                            rate_class: "",              // Keep other fields empty
                            comm_item_No: "",
                            chargeable_wt: "",
                            rate_charge: "",
                            total_freight: "",
                        };
                    });

                    // Update formik values
                    formik.setFieldValue("rows", updatedRows);
                } else {
                    formik.setFieldValue("rows", [{
                        no_of_pkg: "",
                        gross_wt: "",
                        kg_lb: "",
                        rate_class: "",
                        comm_item_No: "",
                        chargeable_wt: "",
                        rate_charge: "",
                        total_freight: "",
                    }]);
                }
            } else {
                formik.setFieldValue("rows", [{
                    no_of_pkg: "",
                    gross_wt: "",
                    kg_lb: "",
                    rate_class: "",
                    comm_item_No: "",
                    chargeable_wt: "",
                    rate_charge: "",
                    total_freight: "",
                }]);
            }
            if (FFQueryDetail.imp_exp) {

                // setImpExp(FFQueryDetail.imp_exp);
                setImpExp(impexp);
            } else {
                setImpExp(impexp);

            }
        } else {
            setImpExp(impexp)
        }

    }, [FFQueryDetail]);

    useEffect(() => {
        if (joborderffdetails) {
            // console.log(joborderffdetails);
            formik.setFieldValue("shipper_id", joborderffdetails.shipper_id ? joborderffdetails.shipper_id : "");
            if (joborderffdetails.shipper_id) {
                handleShipperBranch(joborderffdetails.shipper_id)
            }
            formik.setFieldValue("shipper_branch_id", joborderffdetails.shipper_branch_id ? joborderffdetails.shipper_branch_id : "");
            if (joborderffdetails.shipper_branch_id) {
                handleShipperBanks(joborderffdetails.shipper_branch_id)
            }
            formik.setFieldValue("shipper_branch_bank_account_id", joborderffdetails.shipper_branch_bank_account_id ? joborderffdetails.shipper_branch_bank_account_id : "");
            formik.setFieldValue("consignee_id", joborderffdetails.consignee_id ? joborderffdetails.consignee_id : "");
            if (joborderffdetails.consignee_id) {
                handleConsigneeBranch(joborderffdetails.consignee_id)
            }
            formik.setFieldValue("consignee_branch_id", joborderffdetails.consignee_branch_id ? joborderffdetails.consignee_branch_id : "");
            if (joborderffdetails.consignee_branch_id) {
                handleConsigneeBanks(joborderffdetails.consignee_branch_id)
            }
            formik.setFieldValue("consignee_branch_bank_account_id", joborderffdetails.consignee_branch_bank_account_id ? joborderffdetails.consignee_branch_bank_account_id : "");
            formik.setFieldValue("issuing_carrier_agent_id", joborderffdetails.issuing_carrier_agent_id ? joborderffdetails.issuing_carrier_agent_id : 0);
            formik.setFieldValue("issuing_carrier_agent_name", joborderffdetails.issuing_carrier_agent_name ? joborderffdetails.issuing_carrier_agent_name : "");
            formik.setFieldValue("issuing_carrier_agent_address", joborderffdetails.issuing_carrier_agent_address ? joborderffdetails.issuing_carrier_agent_address : "");
            formik.setFieldValue("agent_iata_code", joborderffdetails.agent_iata_code ? joborderffdetails.agent_iata_code : "");
            formik.setFieldValue("agent_account_number", joborderffdetails.agent_account_number ? joborderffdetails.agent_account_number : "");
            formik.setFieldValue("airport_of_departure_id", joborderffdetails.airport_of_departure_id ? joborderffdetails.airport_of_departure_id : "");
            formik.setFieldValue("airport_of_departure_name", joborderffdetails.airport_of_departure_name ? joborderffdetails.airport_of_departure_name : "");
            formik.setFieldValue("airport_of_destination_id", joborderffdetails.airport_of_destination_id ? joborderffdetails.airport_of_destination_id : "");
            formik.setFieldValue("airport_of_destination_name", joborderffdetails.airport_of_destination_name ? joborderffdetails.airport_of_destination_name : "");
            formik.setFieldValue("to_one", joborderffdetails.to_one ? joborderffdetails.to_one : "");
            formik.setFieldValue("by_first_carrier", joborderffdetails.by_first_carrier ? joborderffdetails.by_first_carrier : "");
            formik.setFieldValue("to_two", joborderffdetails.to_two ? joborderffdetails.to_two : "");
            formik.setFieldValue("by_one", joborderffdetails.by_one ? joborderffdetails.by_one : "");
            formik.setFieldValue("to_three", joborderffdetails.to_three ? joborderffdetails.to_three : "");
            formik.setFieldValue("by_two", joborderffdetails.by_two ? joborderffdetails.by_two : "");
            formik.setFieldValue("flight_no_one", joborderffdetails.flight_no_one ? joborderffdetails.flight_no_one : "");
            formik.setFieldValue("flight_date_one", joborderffdetails.flight_date_one ? joborderffdetails.flight_date_one : "");
            formik.setFieldValue("flight_no_two", joborderffdetails.flight_no_two ? joborderffdetails.flight_no_two : "");
            formik.setFieldValue("flight_date_two", joborderffdetails.flight_date_two ? joborderffdetails.flight_date_two : "");
            formik.setFieldValue("cto", joborderffdetails.cto ? joborderffdetails.cto : "");
            formik.setFieldValue("currency", joborderffdetails.currency ? joborderffdetails.currency : "");
            formik.setFieldValue("chgs_code", joborderffdetails.chgs_code ? joborderffdetails.chgs_code : "");
            formik.setFieldValue("wt_val", joborderffdetails.wt_val ? joborderffdetails.wt_val : "");
            formik.setFieldValue("other", joborderffdetails.other ? joborderffdetails.other : "");
            formik.setFieldValue("declared_value_for_carriage", joborderffdetails.declared_value_for_carriage ? joborderffdetails.declared_value_for_carriage : "");
            formik.setFieldValue("declared_value_for_customs", joborderffdetails.declared_value_for_customs ? joborderffdetails.declared_value_for_customs : "");
            formik.setFieldValue("amount_of_insurance", joborderffdetails.amount_of_insurance ? joborderffdetails.amount_of_insurance : "");
            formik.setFieldValue("handling_info", joborderffdetails.handling_info ? joborderffdetails.handling_info : "");
        }
    }, [joborderffdetails])



    // useEffect(() => {
    //     if (formik.values.chargeable_wt1 && formik.values.rate_charge1) {
    //         let num1 = Number(formik.values.chargeable_wt1);
    //         let num2 = Number(formik.values.rate_charge1);

    //         if (!isNaN(num1) && !isNaN(num2)) {
    //             formik.setFieldValue("total_freight1", num1 * num2)
    //         } else {
    //             formik.setFieldValue("total_freight1", "");
    //         }
    //     } else {
    //         formik.setFieldValue("total_freight1", "");
    //     }
    // }, [formik.values.chargeable_wt1, formik.values.rate_charge1]);

    // useEffect(() => {
    //     if (formik.values.chargeable_wt2 && formik.values.rate_charge2) {
    //         let num1 = Number(formik.values.chargeable_wt2);
    //         let num2 = Number(formik.values.rate_charge2);

    //         if (!isNaN(num1) && !isNaN(num2)) {
    //             formik.setFieldValue("total_freight2", num1 * num2)
    //         } else {
    //             formik.setFieldValue("total_freight2", "");
    //         }
    //     } else {
    //         formik.setFieldValue("total_freight2", "");
    //     }
    // }, [formik.values.chargeable_wt2, formik.values.rate_charge2]);

    // useEffect(() => {
    //     if (formik.values.chargeable_wt3 && formik.values.rate_charge3) {
    //         let num1 = Number(formik.values.chargeable_wt3);
    //         let num2 = Number(formik.values.rate_charge3);

    //         if (!isNaN(num1) && !isNaN(num2)) {
    //             formik.setFieldValue("total_freight3", num1 * num2)
    //         } else {
    //             formik.setFieldValue("total_freight3", "");
    //         }
    //     } else {
    //         formik.setFieldValue("total_freight3", "");
    //     }
    // }, [formik.values.chargeable_wt3, formik.values.rate_charge3])

    // useEffect(() => {
    //     if (formik.values.chargeable_wt4 && formik.values.rate_charge4) {
    //         let num1 = Number(formik.values.chargeable_wt4);
    //         let num2 = Number(formik.values.rate_charge4);

    //         if (!isNaN(num1) && !isNaN(num2)) {
    //             formik.setFieldValue("total_freight4", num1 * num2)
    //         } else {
    //             formik.setFieldValue("total_freight4", "");
    //         }
    //     } else {
    //         formik.setFieldValue("total_freight4", "");
    //     }
    // }, [formik.values.chargeable_wt4, formik.values.rate_charge4])

    useEffect(() => {
        // Perform calculations and update the rows without causing an infinite loop
        const calculateFreight = () => {
            const updatedRows = formik.values.rows.map((row) => {
                const num1 = Number(row.chargeable_wt);
                const num2 = Number(row.rate_charge);

                return {
                    ...row,
                    total_freight: !isNaN(num1) && !isNaN(num2) ? num1 * num2 : "",
                };
            });

            // Only update the rows if something changed to prevent unnecessary updates
            if (JSON.stringify(formik.values.rows) !== JSON.stringify(updatedRows)) {
                formik.setFieldValue("rows", updatedRows, false); // Set `shouldValidate` to `false` to avoid validation triggering on each update
            }
        };

        calculateFreight();
    }, [formik.values.rows.map(row => row.chargeable_wt), formik.values.rows.map(row => row.rate_charge)]);


    useEffect(() => {
        let num1 = !isNaN(Number(formik.values.weight_charge_prepaid)) ? Number(formik.values.weight_charge_prepaid) : 0;
        let num2 = !isNaN(Number(formik.values.valuation_charge_prepaid)) ? Number(formik.values.valuation_charge_prepaid) : 0;
        let num3 = !isNaN(Number(formik.values.tax_prepaid)) ? Number(formik.values.tax_prepaid) : 0;
        let num4 = !isNaN(Number(formik.values.total_due_agent_prepaid)) ? Number(formik.values.total_due_agent_prepaid) : 0;
        let num5 = !isNaN(Number(formik.values.total_due_carrier_prepaid)) ? Number(formik.values.total_due_carrier_prepaid) : 0;
        formik.setFieldValue("total_prepaid", num1 + num2 + num3 + num4 + num5);
    }, [
        formik.values.weight_charge_prepaid,
        formik.values.valuation_charge_prepaid,
        formik.values.tax_prepaid,
        formik.values.total_due_agent_prepaid,
        formik.values.total_due_carrier_prepaid,
    ]);

    useEffect(() => {
        let num1 = !isNaN(Number(formik.values.weight_charge_collect)) ? Number(formik.values.weight_charge_collect) : 0;
        let num2 = !isNaN(Number(formik.values.valuation_charge_collect)) ? Number(formik.values.valuation_charge_collect) : 0;
        let num3 = !isNaN(Number(formik.values.tax_collect)) ? Number(formik.values.tax_collect) : 0;
        let num4 = !isNaN(Number(formik.values.total_due_agent_collect)) ? Number(formik.values.total_due_agent_collect) : 0;
        let num5 = !isNaN(Number(formik.values.total_due_carrier_collect)) ? Number(formik.values.total_due_carrier_collect) : 0;
        formik.setFieldValue("total_collect", num1 + num2 + num3 + num4 + num5);
    }, [
        formik.values.weight_charge_collect,
        formik.values.valuation_charge_collect,
        formik.values.tax_collect,
        formik.values.total_due_agent_collect,
        formik.values.total_due_carrier_collect,
    ]);

    const [disableDownloadPDF, setDisableDownloadPDF] = useState(false);
    const [disableDownloadDOC, setDisableDownloadDOC] = useState(false);


    const downloadSLIPDF = () => {
        setDisableDownloadPDF(true);
        let config = { headers: { 'auth-token': token, user_id: user_id }, responseType: 'blob', };
        try {
            axios.get(`${adminMainUrl}/api/freight/forwarding/air/export/hawb/sli-pdf-download`, config)
                .then(response => {
                    if (response.status == 200) {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'FlexichainSLI.pdf');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setDisableDownloadPDF(false);
                    } else {
                        toast.error(response.error.message);
                        setDisableDownloadPDF(false);
                    }
                }).catch(error => {
                    console.log(error);
                    toast.error(error.message);
                    setDisableDownloadPDF(false);
                })
        } catch (error) {
            console.log(error);
            toast.error(error.message);
            setDisableDownloadPDF(false);
        }
    }

    const downloadSLIDOC = () => {
        setDisableDownloadDOC(true);
        let config = {
            headers: { 'auth-token': token, user_id: user_id },
            responseType: 'blob' // Ensure the response is treated as a binary blob
        };

        try {
            axios.get(`${adminMainUrl}/api/freight/forwarding/air/export/hawb/sli-doc-download`, config)
                .then(response => {
                    if (response.status === 200) {
                        // Create a Blob object from the response data
                        const blob = new Blob([response.data], { type: 'application/msword' });
                        const url = window.URL.createObjectURL(blob);

                        // Create an anchor element and trigger the download
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'FlexichainSLI.doc'); // Set the filename
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link); // Clean up the DOM
                        setDisableDownloadDOC(false);
                    } else {
                        toast.error(response.error.message || "Error downloading the document");
                        setDisableDownloadDOC(false);
                    }
                })
                .catch(error => {
                    console.error(error);
                    toast.error(error.message || "Error during download");
                    setDisableDownloadDOC(false);
                });
        } catch (error) {
            console.error(error);
            toast.error(error.message || "Unexpected error occurred");
            setDisableDownloadDOC(false);
        }
    };


    // const downloadSLIDOC = () => {
    //     setDisableDownloadDOC(true);
    //     let config = { headers: { 'auth-token': token, user_id: user_id } };
    //     try {
    //         axios.get(`${adminMainUrl}/api/freight/forwarding/air/export/hawb/sli-doc-download`, config)
    //             .then(response => {
    //                 if (response.status === 200) {
    //                     setDisableDownloadDOC(false);
    //                 } else {
    //                     toast.error(response.error.message);
    //                     setDisableDownloadDOC(false);
    //                 }
    //             })
    //             .catch(error => {
    //                 console.log(error);
    //                 toast.error(error.message);
    //                 setDisableDownloadDOC(false);
    //             });
    //     } catch (error) {
    //         console.log(error);
    //         toast.error(error.message);
    //         setDisableDownloadDOC(false);
    //     }
    // };


    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="row">
                    <h3 className='mt-2'>HAWB</h3>
                    <h4 className='mt-2'>Party Details</h4>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                SLI received
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <select
                                    className='form-control form-control-sm'
                                    name="is_sli_recived"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.is_sli_recived}
                                >
                                    <option value="" disabled>-Select an option-</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2 d-flex align-items-center justify-content-end">
                        {accessedPermission.includes("ff_ae_console_shipment_hawb_sli_download") && <div className="row d-flex justify-content-end">
                            <div className="col-md-6"><button className="btn btn-sm btn-primary" type="button" onClick={downloadSLIPDF} disabled={disableDownloadPDF}>{disableDownloadPDF ? <><i className="fas fa-spinner fa-spin"></i> Downloading...</> : <><i className="fa-solid fa-download"></i>  Download SLI (PDF)</>}</button></div>
                            {/* <div className="col-md-6"><button className="btn btn-sm btn-primary" type="button" onClick={downloadSLIDOC} style={{ whiteSpace: "nowrap" }} disabled={disableDownloadDOC}>{disableDownloadDOC ? <><i className="fas fa-spinner fa-spin"></i> Downloading...</> : <><i className="fa-solid fa-download"></i>  Download SLI (DOC)</>}</button></div> */}
                            <div className="col-md-6"><Link className="btn btn-sm btn-primary" type="button" style={{ whiteSpace: "nowrap" }} to={`${adminMainUrl}/FreightForwardingSLI/FF_AI_SLI.docx`}>{disableDownloadDOC ? <><i className="fas fa-spinner fa-spin"></i> Downloading...</> : <><i className="fa-solid fa-download"></i>  Download SLI (DOC)</>}</Link></div>

                        </div>}
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                HAWB  No.
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={hawbStockOptions}
                                    styles={customStyles}
                                    name="hawb_stock_id"
                                    onChange={option => {
                                        formik.setFieldValue("hawb_stock_id", option.value);
                                    }}
                                    value={hawbStockOptions.find(option => option.value === formik.values.hawb_stock_id || null)}
                                    isLoading={loadingFFAirExpHAWBStocks}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Shipper
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={shipperOrganisationOptions}
                                    styles={customStyles}
                                    name="shipper_id"
                                    onChange={option => {
                                        formik.setFieldValue("shipper_branch_id", "");
                                        formik.setFieldValue("shipper_branch_bank_account_id", "");
                                        setShipperBranchOptions([]);
                                        setShipperBankOptions([]);
                                        formik.setFieldValue('shipper_id', option.value);
                                        handleShipperBranch(option.value);
                                    }}
                                    value={shipperOrganisationOptions.find(option => option.value === formik.values.shipper_id || null)}
                                    isLoading={loadingOrganisation}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Shipper Branch
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={shipperBranchOptions}
                                    styles={customStyles}
                                    name="shipper_branch_id"
                                    onChange={option => {
                                        formik.setFieldValue("shipper_branch_bank_account_id", "");
                                        setShipperBankOptions([]);
                                        formik.setFieldValue('shipper_branch_id', option.value);
                                        handleShipperBanks(option.value);
                                    }}
                                    value={shipperBranchOptions.find(option => option.value === formik.values.shipper_branch_id || null)}
                                    isLoading={loadingFFAirExpShipperBranchList}
                                // isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Shipper Branch Account No.
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={shipperBankOptions}
                                    styles={customStyles}
                                    name="shipper_branch_bank_account_id"
                                    onChange={option => {
                                        formik.setFieldValue('shipper_branch_bank_account_id', option.value);
                                    }}
                                    value={shipperBankOptions.find(option => option.value === formik.values.shipper_branch_bank_account_id || null)}
                                    isLoading={loadingFFAirExpConsigneeBranchBankList}
                                // isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-md-6"></div> */}
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Consignee
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={consigneeOrganisationOptions}
                                    styles={customStyles}
                                    name="quotation_id"
                                    onChange={option => {
                                        setConsigneeBranchOptions([]);
                                        setConsigneeBankOptions([]);
                                        formik.setFieldValue("consignee_branch_id", "");
                                        formik.setFieldValue("consignee_branch_bank_account_id", "");
                                        formik.setFieldValue('consignee_id', option.value);
                                        handleConsigneeBranch(option.value);
                                    }}
                                    value={consigneeOrganisationOptions.find(option => option.value === formik.values.consignee_id || null)}
                                    isLoading={loadingOrganisation}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Consignee Branch
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={consigneeBranchOptions}
                                    styles={customStyles}
                                    name="consignee_branch_id"
                                    onChange={option => {
                                        setConsigneeBankOptions([]);
                                        formik.setFieldValue("consignee_branch_bank_account_id", "");
                                        formik.setFieldValue('consignee_branch_id', option.value);
                                        handleConsigneeBanks(option.value);
                                    }}
                                    value={consigneeBranchOptions.find(option => option.value === formik.values.consignee_branch_id || null)}
                                    isLoading={loadingFFAirExpShipperBranchList}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Consignee Branch Account No.
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={consigneeBankOptions}
                                    styles={customStyles}
                                    name="consignee_branch_bank_account_id"
                                    onChange={option => {
                                        formik.setFieldValue('consignee_branch_bank_account_id', option.value);
                                    }}
                                    value={consigneeBankOptions.find(option => option.value === formik.values.consignee_branch_bank_account_id || null)}
                                    isLoading={loadingFFAirExpConsigneeBranchBankList}
                                // isDisabled={false}  
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                IATA Agent
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={iataAgentOptions}
                                    styles={customStyles}
                                    name="issuing_carrier_agent_id"
                                    onChange={option => {
                                        formik.setFieldValue('issuing_carrier_agent_id', option.value);
                                    }}
                                    value={iataAgentOptions.find(option => option.value === formik.values.issuing_carrier_agent_id || null)}
                                // isLoading={loadingFFAirExpConsigneeBranchBankList}
                                // isDisabled={false}  
                                />
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-md-6"></div> */}

                    {/* Agent Name */}
                    {/* <InputTextJSX labelText={"Agent Name"} nameValue={"issuing_carrier_agent_name"} value={formik.values.issuing_carrier_agent_name} onChange={formik.handleChange} maxLength={100} />
                    <InputTextJSX labelText={"Agent Address"} nameValue={"issuing_carrier_agent_address"} value={formik.values.issuing_carrier_agent_address} onChange={formik.handleChange} />
                    <InputTextJSX labelText={"Agent IATA Code"} nameValue={"agent_iata_code"} value={formik.values.agent_iata_code} onChange={formik.handleChange} maxLength={10} />
                    <InputTextJSX labelText={"Agent Account No."} nameValue={"agent_account_number"} value={formik.values.agent_account_number} onChange={formik.handleChange} maxLength={30} /> */}


                    <h4 className='mt-2'>Flight Booking/ Routing</h4>

                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Airport of Departure
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={airportOptions}
                                    styles={customStyles}
                                    name="airport_of_departure_id"
                                    onChange={(option) => {
                                        formik.setFieldValue("airport_of_departure_id", option.value)
                                        formik.setFieldValue("airport_of_departure_name", option.label)
                                    }}
                                    value={airportOptions.find(option => option.value === formik.values.airport_of_departure_id || null)}
                                    isLoading={loadingAirport}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Airport of Destination
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={airportOptions}
                                    styles={customStyles}
                                    name="airport_of_destination_id"
                                    onChange={(option) => {
                                        formik.setFieldValue("airport_of_destination_id", option.value)
                                        formik.setFieldValue("airport_of_destination_name", option.label)
                                    }}
                                    value={airportOptions.find(option => option.value === formik.values.airport_of_destination_id || null)}
                                    isLoading={loadingAirport}
                                />
                            </div>
                        </div>
                    </div>


                    <InputTextJSX labelText={"To"} nameValue={"to_one"} value={formik.values.to_one} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                    <InputTextJSX labelText={"By First Carrier"} nameValue={"by_first_carrier"} value={formik.values.by_first_carrier} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                    <InputTextJSX labelText={"To"} nameValue={"to_two"} value={formik.values.to_two} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                    <InputTextJSX labelText={"By"} nameValue={"by_one"} value={formik.values.by_one} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                    <InputTextJSX labelText={"To"} nameValue={"to_three"} value={formik.values.to_three} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                    <InputTextJSX labelText={"By"} nameValue={"by_two"} value={formik.values.by_two} onChange={formik.handleChange} splithalf={true} maxLength={30} />

                    <div className={`col-md-6 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                CTO
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <select
                                    className="form-control form-control-sm"
                                    id="cto"
                                    name="cto"
                                    value={formik.values.cto}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                >
                                    <option value="" disabled>-Select an option-</option>
                                    <option value="DCSC">DCSC</option>
                                    <option value="CELEBI">CELEBI</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <InputTextJSX labelText={"Flt No 1"} nameValue={"flight_no_one"} value={formik.values.flight_no_one} onChange={formik.handleChange} maxLength={15} />
                    {/* <InputDateJSX labelText={"Flt Dt 1"} nameValue={"flight_date_one"} value={formik.values.flight_date_one} onChange={formik.handleChange} /> */}
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Flt Dt 1
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    id={"flight_date_one"}
                                    name={"flight_date_one"}
                                    value={formik.values.flight_date_one}
                                    onChange={formik.handleChange}
                                    min={new Date().toISOString().split("T")[0]}
                                />
                            </div>
                        </div>
                    </div>
                    <InputTextJSX labelText={"Flt No 2"} nameValue={"flight_no_two"} value={formik.values.flight_no_two} onChange={formik.handleChange} maxLength={15} />
                    {/* <InputDateJSX labelText={"Flt Dt 2"} nameValue={"flight_date_two"} value={formik.values.flight_date_two} onChange={formik.handleChange} /> */}
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Flt Dt 2
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    id={"flight_date_two"}
                                    name={"flight_date_two"}
                                    value={formik.values.flight_date_two}
                                    onChange={formik.handleChange}
                                    min={new Date().toISOString().split("T")[0]}
                                />
                            </div>
                        </div>
                    </div>

                    <h4 className='mt-2'>Charge Declaration</h4>
                    <SelectReactJSX
                        labelText={"Currency"}
                        nameValue={"currency"}
                        onChange={(option) => { formik.setFieldValue("currency", option.value) }}
                        options={currencyOptions}
                        value={currencyOptions.find(option => option.value === formik.values.currency || null)}
                        isLoading={loadingCurrency}
                    />

                    <div className={`col-md-6 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                CHGS CODE
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <select
                                    className="form-control form-control-sm"
                                    id="chgs_code"
                                    name="chgs_code"
                                    value={formik.values.chgs_code}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                >
                                    <option value="" disabled>-Select an option-</option>
                                    <option value="PP">PP</option>
                                    <option value="PC">PC</option>
                                    <option value="CP">CP</option>
                                    <option value="CC">CC</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className={`col-md-6 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Wt/Val(P/C)
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <select
                                    className="form-control form-control-sm"
                                    id="wt_val"
                                    name="wt_val"
                                    value={formik.values.wt_val}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                >
                                    <option value="" disabled>-Select an option-</option>
                                    <option value="P">P</option>
                                    <option value="C">C</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className={`col-md-6 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Other(P/C)
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <select
                                    className="form-control form-control-sm"
                                    id="other"
                                    name="other"
                                    value={formik.values.other}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                >
                                    <option value="" disabled>-Select an option-</option>
                                    <option value="P">P</option>
                                    <option value="C">C</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <InputTextJSX labelText={"Declared Value for Carriage"} nameValue={"declared_value_for_carriage"} value={formik.values.declared_value_for_carriage} onChange={formik.handleChange} />
                    <InputTextJSX labelText={"Declared Value for Customs"} nameValue={"declared_value_for_customs"} value={formik.values.declared_value_for_customs} onChange={formik.handleChange} />
                    <InputTextJSX labelText={"Amount of Insurance"} nameValue={"amount_of_insurance"} value={formik.values.amount_of_insurance} onChange={formik.handleChange} />
                    <TextAreaJSX labelText="Handeling Info" nameValue="handling_info" value={formik.values.handling_info} onChange={formik.handleChange} maxLength={430} showWordCount={true} />

                    <h4 className='mt-2'>Rate Description</h4>
                    <div className="table-responsive">
                        <table className="table table-striped table-sm">
                            <thead>
                                <tr>
                                    <th scope="col">No.of Pkg</th>
                                    <th scope="col">Gross Wt.</th>
                                    <th scope="col">Kg/ Lb /Ton</th>
                                    <th scope="col">Rate Class</th>
                                    <th scope="col">Comm. Item No</th>
                                    <th scope="col">Chargeable Wt.</th>
                                    <th scope="col">Rate/ Charge</th>
                                    <th scope="col">Total Freight</th>
                                </tr>
                            </thead>
                            <tbody>
                                {formik.values.rows.map((row, index) => (
                                    <tr key={index}>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].no_of_pkg`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.no_of_pkg}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9]/g, '');
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].gross_wt`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.gross_wt}
                                                onInput={(event) => {
                                                    let value = event.target.value;

                                                    value = value.replace(/[^0-9.]/g, '');

                                                    const parts = value.split('.');

                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }

                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }

                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <select
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].kg_lb`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.kg_lb}
                                            >
                                                <option value="" disabled>-Select an option-</option>
                                                <option value="Kgs">Kgs</option>
                                                <option value="Lbs">Lbs</option>
                                                <option value="Ton">Ton</option>
                                            </select>
                                        </td>
                                        <td>
                                            <select
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].rate_class`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.rate_class}
                                            >
                                                <option value="">-Select an option-</option>
                                                {
                                                    rateclassOptions.map((v, i) => {
                                                        return <option value={v.value} key={i + 1}>{v.label}</option>
                                                    })
                                                }
                                                {/* <option value="Q">Q</option>
                                                <option value="B">B</option>
                                                <option value="R">R</option>
                                                <option value="S">S</option>
                                                <option value="M">M</option>
                                                <option value="N">N</option>
                                                <option value="K">K</option>
                                                <option value="C">C</option>
                                                <option value="X">X</option>
                                                <option value="E">E</option>
                                                <option value="U">U</option>
                                                <option value="Y">Y</option> */}
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].comm_item_No`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.comm_item_No}
                                                maxLength={30}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].chargeable_wt`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.chargeable_wt}
                                                onInput={(event) => {
                                                    let value = event.target.value;

                                                    value = value.replace(/[^0-9.]/g, '');

                                                    const parts = value.split('.');

                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }

                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }

                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].rate_charge`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.rate_charge}
                                                onInput={(event) => {
                                                    let value = event.target.value;

                                                    value = value.replace(/[^0-9.]/g, '');

                                                    const parts = value.split('.');

                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }

                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }

                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].total_freight`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.total_freight}
                                                disabled
                                            />
                                        </td>
                                        <td>
                                            {formik.values.rows.length > 1 && (
                                                <button
                                                    type="button"
                                                    title='Remove rates'
                                                    className="btn btn-sm btn-danger me-1"
                                                    onClick={() => {
                                                        const newRows = formik.values.rows.filter(
                                                            (_, i) => i !== index
                                                        );
                                                        formik.setFieldValue("rows", newRows);
                                                    }}
                                                >
                                                    -
                                                </button>
                                            )}
                                            {index === formik.values.rows.length - 1 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-primary ms-1"
                                                    onClick={() => {
                                                        const newRows = [...formik.values.rows];
                                                        newRows.push({
                                                            no_of_pkg: "",
                                                            gross_wt: "",
                                                            kg_lb: "",
                                                            rate_class: "",
                                                            comm_item_No: "",
                                                            chargeable_wt: "",
                                                            rate_charge: "",
                                                            total_freight: "",
                                                        });
                                                        formik.setFieldValue("rows", newRows);
                                                    }}
                                                >
                                                    +
                                                </button>
                                            )}

                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>

                    <TextAreaJSX labelText="Nature and Quantity" nameValue="nature_and_qty" value={formik.values.nature_and_qty} onChange={formik.handleChange} maxLength={400} showWordCount={true} />
                    <TextAreaJSX labelText="Remarks" nameValue="remarks" value={formik.values.remarks} onChange={formik.handleChange} maxLength={380} showWordCount={true} />

                    <h4 className='mt-2'>Prepaid / Collect Charge Declaration</h4>

                    <div className="table-responsive">
                        <table className="table table-striped table-sm">
                            <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col">Prepaid</th>
                                    <th scope="col">Collect</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* Weight Charge */}
                                <tr>
                                    <td>
                                        Weight Charge
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="weight_charge_prepaid"
                                            id="weight_charge_prepaid"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.weight_charge_prepaid}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="weight_charge_collect"
                                            id="weight_charge_collect"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.weight_charge_collect}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                </tr>
                                {/* Valuation Charge */}
                                <tr>
                                    <td>
                                        Valuation Charge
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="valuation_charge_prepaid"
                                            id="valuation_charge_prepaid"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.valuation_charge_prepaid}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="valuation_charge_collect"
                                            id="valuation_charge_collect"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.valuation_charge_collect}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                </tr>
                                {/* Tax */}
                                <tr>
                                    <td>
                                        Tax
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="tax_prepaid"
                                            id="tax_prepaid"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.tax_prepaid}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="tax_collect"
                                            id="tax_collect"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.tax_collect}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                </tr>
                                {/* Total Due Agent */}
                                <tr>
                                    <td>
                                        Total Due Agent
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="total_due_agent_prepaid"
                                            id="total_due_agent_prepaid"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.total_due_agent_prepaid}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="total_due_agent_collect"
                                            id="total_due_agent_collect"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.total_due_agent_collect}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                </tr>
                                {/* Total Due Carrier */}
                                <tr>
                                    <td>
                                        Total Due Carrier
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="total_due_carrier_prepaid"
                                            id="total_due_carrier_prepaid"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.total_due_carrier_prepaid}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="total_due_carrier_collect"
                                            id="total_due_carrier_collect"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.total_due_carrier_collect}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                </tr>
                                {/* Total  */}
                                <tr>
                                    <td>
                                        Total
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="total_prepaid"
                                            id="total_prepaid"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.total_prepaid}
                                            maxLength={100}
                                            disabled
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="total_collect"
                                            id="total_collect"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.total_collect}
                                            maxLength={100}
                                            disabled
                                        />
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                    <h4 className='mt-2'>Add Dimension</h4>
                    <div className="table-responsive">
                        <table className="table table-striped table-sm">
                            <thead>
                                <tr>
                                    <th scope="col">Length</th>
                                    <th scope="col">Width</th>
                                    <th scope="col">Height</th>
                                    <th scope="col">Pkgs</th>
                                    <th scope="col">Unit</th>
                                    {/* <th scope="col"></th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {formik.values.dimension_rows.map((row, index) => (
                                    <tr key={index}>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`dimension_rows[${index}].length`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.length}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9.]/g, '');
                                                    const parts = value.split('.');
                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }
                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`dimension_rows[${index}].width`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.width}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9.]/g, '');
                                                    const parts = value.split('.');
                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }
                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`dimension_rows[${index}].height`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.height}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9.]/g, '');
                                                    const parts = value.split('.');
                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }
                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`dimension_rows[${index}].pkgs`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.pkgs}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9.]/g, '');
                                                    const parts = value.split('.');
                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }
                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <select
                                                className="form-control form-control-sm"
                                                name={`dimension_rows[${index}].unit`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.unit}

                                            >
                                                <option value="">-Select an option-</option>
                                                <option value="Cm">Cm</option>
                                                <option value="Inch">Inch</option>
                                            </select>
                                        </td>
                                        <td>
                                            {formik.values.dimension_rows.length > 1 && (
                                                <button
                                                    type="button"
                                                    title='Remove rates'
                                                    className="btn btn-sm btn-danger me-1"
                                                    onClick={() => {
                                                        const newRows = formik.values.dimension_rows.filter(
                                                            (_, i) => i !== index
                                                        );
                                                        formik.setFieldValue("dimension_rows", newRows);
                                                    }}
                                                >
                                                    -
                                                </button>
                                            )}
                                            {index === formik.values.dimension_rows.length - 1 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-primary ms-1"
                                                    onClick={() => {
                                                        const newRows = [...formik.values.dimension_rows];
                                                        newRows.push({
                                                            length: 0,
                                                            width: 0,
                                                            height: 0,
                                                            pkgs: 0,
                                                            unit: "",
                                                        });
                                                        formik.setFieldValue("dimension_rows", newRows);
                                                    }}
                                                >
                                                    +
                                                </button>
                                            )}

                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>

                    <h4 className='mt-2'>Add due Carrier Charges</h4>
                    <div className="table-responsive">
                        <table className="table table-striped table-sm">
                            <thead>
                                <tr>
                                    <th scope="col">Charge Name</th>
                                    <th scope="col">Rate</th>
                                    <th scope="col">Amount</th>
                                    <th scope="col">CSR Amount</th>
                                    <th scope="col">P/C</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {formik.values.due_carrier_charge_rows.map((row, index) => (
                                    <tr key={index}>
                                        <td>
                                            <select
                                                className="form-control form-control-sm"
                                                name={`due_carrier_charge_rows[${index}].charge_head_id`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.charge_head_id}
                                            >
                                                <option value="" >-Select an option-</option>
                                                {
                                                    chargeHeadOptions.map((v, i) => {
                                                        return <option value={v.value} key={i + 1}>{v.label}</option>
                                                    })
                                                }
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`due_carrier_charge_rows[${index}].rate`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.rate}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9.]/g, '');
                                                    const parts = value.split('.');
                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }
                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`due_carrier_charge_rows[${index}].amount`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.amount}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9.]/g, '');
                                                    const parts = value.split('.');
                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }
                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`due_carrier_charge_rows[${index}].csr_amount`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.csr_amount}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9.]/g, '');
                                                    const parts = value.split('.');
                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }
                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <select
                                                className="form-control form-control-sm"
                                                name={`due_carrier_charge_rows[${index}].p_c`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.p_c}
                                            >
                                                <option value="" disabled>-Select an option-</option>
                                                <option value="P">P</option>
                                                <option value="C">C</option>
                                            </select>
                                        </td>
                                        <td>
                                            {formik.values.due_carrier_charge_rows.length > 1 && (
                                                <button
                                                    type="button"
                                                    title='Remove rates'
                                                    className="btn btn-sm btn-danger me-1"
                                                    onClick={() => {
                                                        const newRows = formik.values.due_carrier_charge_rows.filter(
                                                            (_, i) => i !== index
                                                        );
                                                        formik.setFieldValue("due_carrier_charge_rows", newRows);
                                                    }}
                                                >
                                                    -
                                                </button>
                                            )}
                                            {index === formik.values.due_carrier_charge_rows.length - 1 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-primary ms-1"
                                                    onClick={() => {
                                                        const newRows = [...formik.values.due_carrier_charge_rows];
                                                        newRows.push({
                                                            charge_head_id: 0,
                                                            rate: 0,
                                                            amount: 0,
                                                            csr_amount: 0,
                                                            p_c: "",
                                                        });
                                                        formik.setFieldValue("due_carrier_charge_rows", newRows);
                                                    }}
                                                >
                                                    +
                                                </button>
                                            )}

                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>

                    <h4 className='mt-2'>Add due Agent Charges</h4>
                    <div className="table-responsive">
                        <table className="table table-striped table-sm">
                            <thead>
                                <tr>
                                    <th scope="col">Charge Name</th>
                                    <th scope="col">Self</th>
                                    <th scope="col">Sub Agent</th>
                                    <th scope="col">Tie Up</th>
                                    <th scope="col">IATA</th>
                                    <th scope="col">STax</th>
                                    <th scope="col">ECess</th>
                                    <th scope="col">HCess</th>
                                    <th scope="col">SBCess</th>
                                    <th scope="col">KKC</th>
                                    <th scope="col">Rate</th>
                                    <th scope="col">Amount</th>
                                    <th scope="col">Bill Amount</th>
                                    <th scope="col">P/C</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {formik.values.due_agent_charge_rows.map((row, index) => (
                                    <tr key={index}>
                                        <td>
                                            <select
                                                className="form-control form-control-sm"
                                                name={`due_agent_charge_rows[${index}].charge_head_id`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.charge_head_id}
                                            >
                                                <option value="">-Select an option-</option>
                                                {
                                                    chargeHeadOptions.map((v, i) => {
                                                        return <option value={v.value} key={i + 1}>{v.label}</option>
                                                    })
                                                }
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`due_agent_charge_rows[${index}].self_amount`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.self_amount}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9.]/g, '');
                                                    const parts = value.split('.');
                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }
                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`due_agent_charge_rows[${index}].sub_agent_amount`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.sub_agent_amount}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9.]/g, '');
                                                    const parts = value.split('.');
                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }
                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`due_agent_charge_rows[${index}].tie_up_amount`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.tie_up_amount}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9.]/g, '');
                                                    const parts = value.split('.');
                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }
                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`due_agent_charge_rows[${index}].iata_amount`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.iata_amount}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9.]/g, '');
                                                    const parts = value.split('.');
                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }
                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`due_agent_charge_rows[${index}].stax_amount`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.stax_amount}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9.]/g, '');
                                                    const parts = value.split('.');
                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }
                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`due_agent_charge_rows[${index}].ecess_amount`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.ecess_amount}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9.]/g, '');
                                                    const parts = value.split('.');
                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }
                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`due_agent_charge_rows[${index}].hcess_amount`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.hcess_amount}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9.]/g, '');
                                                    const parts = value.split('.');
                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }
                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`due_agent_charge_rows[${index}].sbcess_amount`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.sbcess_amount}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9.]/g, '');
                                                    const parts = value.split('.');
                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }
                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`due_agent_charge_rows[${index}].kkc_amount`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.kkc_amount}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9.]/g, '');
                                                    const parts = value.split('.');
                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }
                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`due_agent_charge_rows[${index}].rate`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.rate}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9.]/g, '');
                                                    const parts = value.split('.');
                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }
                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`due_agent_charge_rows[${index}].amount`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.amount}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9.]/g, '');
                                                    const parts = value.split('.');
                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }
                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`due_agent_charge_rows[${index}].bill_amount`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.bill_amount}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9.]/g, '');
                                                    const parts = value.split('.');
                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }
                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <select
                                                className="form-control form-control-sm"
                                                name={`due_agent_charge_rows[${index}].p_c`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.p_c}
                                            >
                                                <option value="" disabled>-Select an option-</option>
                                                <option value="P">P</option>
                                                <option value="C">C</option>
                                            </select>
                                        </td>
                                        <td>
                                            {formik.values.due_agent_charge_rows.length > 1 && (
                                                <button
                                                    type="button"
                                                    title='Remove rates'
                                                    className="btn btn-sm btn-danger me-1"
                                                    onClick={() => {
                                                        const newRows = formik.values.due_agent_charge_rows.filter(
                                                            (_, i) => i !== index
                                                        );
                                                        formik.setFieldValue("due_agent_charge_rows", newRows);
                                                    }}
                                                >
                                                    -
                                                </button>
                                            )}
                                            {index === formik.values.due_agent_charge_rows.length - 1 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-primary ms-1"
                                                    onClick={() => {
                                                        const newRows = [...formik.values.due_agent_charge_rows];
                                                        newRows.push({
                                                            charge_head_id: 0,
                                                            self_amount: 0,
                                                            sub_agent_amount: 0,
                                                            tie_up_amount: 0,
                                                            iata_amount: 0,
                                                            stax_amount: 0,
                                                            ecess_amount: 0,
                                                            hcess_amount: 0,
                                                            sbcess_amount: 0,
                                                            kkc_amount: 0,
                                                            rate: 0,
                                                            amount: 0,
                                                            bill_amount: 0,
                                                            p_c: "",
                                                        });
                                                        formik.setFieldValue("due_agent_charge_rows", newRows);
                                                    }}
                                                >
                                                    +
                                                </button>
                                            )}

                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>

                    <InputDateJSX labelText="Airway Bill Date" nameValue="airwaybill_date" value={formik.values.airwaybill_date} onChange={formik.handleChange} minToday={true}/>
                    <InputDateJSX labelText="CSR Date" nameValue="clearance_Exec_date" value={formik.values.clearance_Exec_date} onChange={formik.handleChange} minToday={true}/>
                    <InputDateJSX labelText="Clearance/Exec.Dt" nameValue="CSR_date" value={formik.values.CSR_date} onChange={formik.handleChange} minToday={true}/>
                    <InputDateJSX labelText="Executed At" nameValue="executed_at" value={formik.values.executed_at} onChange={formik.handleChange} minToday={true}/>




                </div>
                <div className="row d-flex justify-content-end mt-2">
                    <div className="col-md-6 d-flex justify-content-end">
                        <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                            {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Add"}
                        </button>
                    </div>
                </div>
            </form>

        </>
    )
}

export default ConsoleShipmentHAWBAdd